import type { SubmissionAnswers } from '#submissions'

import type { SurveyVariables } from './surveyVariables'

export type Payload = {
  answers: SubmissionAnswers
  vars: SurveyVariables
}
export type OnErrorFn = (error: Error, expression: string) => void

/**
 * @param expression - The expression string to evaluate (e.g., "answers.age > 18", "profile.userGroup.maritalStatus == 'married'")
 * @param answers - Record of questionId to answer value for condition evaluation
 * @param profile - Optional profile object for profile data access (e.g., profile.maritalStatus)
 * @param onError - Optional callback function to handle evaluation errors
 * @returns true if condition evaluates to true, false otherwise
 */
export const evaluateExpression = <ExpectingResult>(
  expression: string,
  { answers, vars }: Payload,
  onError?: OnErrorFn
): ExpectingResult | undefined => {
  try {
    const fn = new Function('vars', 'answers', 'return (' + expression + ');')
    return fn(vars, answers) as ExpectingResult
  } catch (error) {
    onError?.(error as Error, expression)
    return undefined
  }
}

export const evaluateBooleanCondition = (
  condition: string,
  payload: Payload,
  onError?: OnErrorFn
): boolean => {
  try {
    return Boolean(evaluateExpression<boolean>(condition, payload, onError))
  } catch {
    return false
  }
}
